import React, { useState } from 'react';
import T from 'prop-types';
import { Menu, Dropdown } from 'antd';

import { PopoverWithContext } from '../popover-with-context';
import { PopupDots, PopupDot } from './styled-components';

export const DropdownWithDots = ({ className, overlay, overlayStyle }) => {
  const [visible, setVisible] = useState(false);
  const handleMenuClick = e =>
    !e.target.dataset.popconfirmStayOpen && setVisible(false);


  return (
    <PopoverWithContext
      component={Dropdown}
      className={className}
      overlayStyle={overlayStyle}
      overlay={
        <Menu
          style={{ padding: 0 }}
          onClick={e => handleMenuClick(e)}
        >
          {overlay}
        </Menu>
      }
      visible={visible}
      onVisibleChange={() => setVisible(!visible)}
      trigger={['click']}
      placement="bottomRight"
    >
      <PopupDots>
        <PopupDot />
        <PopupDot />
        <PopupDot />
      </PopupDots>
    </PopoverWithContext>
  );
};

DropdownWithDots.propTypes = {
  overlay: T.element.isRequired,
  className: T.string,
  overlayStyle: T.object,
};

DropdownWithDots.defaultProps = {
  className: '',
  overlayStyle: { zIndex: 11 },
};



// WEBPACK FOOTER //
// ./src/components/popovers/dropdown-with-dots/index.js